import { Checkbox, Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import DeleteModal from "../../../components/DeleteModal";
import NoDataTable from "../../../components/NoDataTable";
import InsideHeader from "../../../components/InsideHeader";
import {
  fetchPrItem,
  fetchStaffExempt,
  fetchStaffItem,
} from "../../../features/dropdown/dropdownSlice";
import { 
  deleteStaffItem,
} from "../../../features/staff-setting/staffSettingSlice";
import FilterModal from "./modal/FilterModal";
import svg38 from "../../../assets/svg/svg38.svg";
import svg56 from "../../../assets/svg/svg56.svg";
import MaterialIcon from "material-icons-react";
import AddStaffTransactionModal from "./modal/AddStaffTransactionModal";
import SalaryModal from "./modal/SalaryModal";
import PeriodModal from "./modal/PeriodModal";
import { getMonthName, numberWithCommas } from "../../../utils";

export default function StaffTransactionTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { staffItem, loading, staffItemCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffloading } = useSelector((state) => state.staff);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);
  const [openSalary, setopenSalary] = useState(false);
  const [openPeriod, setopenPeriod] = useState(false);

  function handleCancel() {
    setopen(false);
  }
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchStaffExempt());
    await setFilters([]);
  };

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deleteStaffItem({
        stId_id: prodd?.stId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchStaffItemData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleAdd = async () => {
    await setopen(true);
    await setProdd("");
  };

  const handleEdit = () => {
    setopen(true);
  };
  const handleSalary = () => {
    setopenSalary(true);
  };
  const handlePeriodEnd = () => {
    setopenPeriod(true);
  };
  const handleCancelPeriod = () => {
    setopenPeriod(false);
  };
  const handleCancelSalary = () => {
    setopenSalary(false);
  };
  
  const handleAttendanceSummary = () => {
    navigate('/attendance-summary/add/file-upload')
  }

  const settingItemsQuickActions = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleAdd}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Add Staff Item
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleSalary}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Salary Process
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handlePeriodEnd}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Period End
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          onClick={handleAttendanceSummary}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Upload Attendance Summary
        </Link>
      ),
    },
    
  ];

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <div
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans   !text-lightBlack"
        >
          Delete
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "Personnel No",
      dataIndex: "ppPfno",
      sorter: (a, b) => a.ppPfno.localeCompare(b.ppPfno),
    },
    {
      title: "Personnel Name",
      dataIndex: "ppFullname",
      sorter: (a, b) => a.ppFullname.localeCompare(b.ppFullname),
    },

    {
      title: "Item Code",
      dataIndex: "itemcode",
      sorter: (a, b) => a.itemcode.localeCompare(b.itemcode),
    },
    {
      title: "Item Name",
      dataIndex: "itemname",
      sorter: (a, b) => a.itemname.localeCompare(b.itemname),
    },
    {
      title: "Type",
      dataIndex: "shHdrname",
      sorter: (a, b) => a.shHdrname.localeCompare(b.shHdrname),
    },
    {
      title: "Year",
      dataIndex: "fpPyear",
      sorter: (a, b) => a.fpPyear - b.fpPyear,
    },
    {
      title: "Month",
      dataIndex: "calendarMonth",
      render:(item)=>{
        return(
          <div>{getMonthName(item)}</div>
        )
      },
      sorter: (a, b) => a.calendarMonth - b.calendarMonth,
    },
    {
      title: "Pay Period",
      dataIndex: "fpPmonth", 
      sorter: (a, b) => a.fpPmonth.localeCompare(b.fpPmonth), 
    },

 
    {
      title: "Has Daily Rate",
      dataIndex: "hasDailyRate",
      render: (item) => {
        return (
          <div>
            {item == null || item == false ? (
              <Checkbox checked={false}></Checkbox>
            ) : item == true ? (
              <Checkbox checked={true}></Checkbox>
            ) : null}
          </div>
        );
      },

      
      sorter: (a, b) =>
        a.isReceiverNumberVerified.localeCompare(b.isReceiverNumberVerified),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
    },
    {
      title: "Rate",
      dataIndex: "rate",
      sorter: (a, b) => a.rate - b.rate,
    },
  
    {
      title: "Amount",
      dataIndex: "stAmount",
      render:(item)=>{
        return(
          <div>{numberWithCommas(item)}</div>
        )
      },
      sorter: (a, b) => a.stAmount - b.stAmount,
    },
    
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchStaffItemData(page, size) {
    dispatch(
      fetchStaffItem({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }
  async function fetchPrItemData() {
    dispatch(fetchPrItem());
  }

  useEffect(() => {
    fetchStaffItemData();
    fetchPrItemData()
  }, []); 
  
  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Staff Items Information"
        subtitle="Manage Staff Items within your institution"
        back={false}
      />
    
        <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
          <div className="flex flex-col w-full lg:px-10 px-3 ">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Staff Items Details
            </h3>
            <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
              <div className="flex items-center">
                <span>
                  {" "}
                  <button
                    onClick={showModalFilter}
                    type="button"
                    className={`bg-transparent flex items-center gap-x-'1' ${
                      Object?.keys(formData)?.length > 0
                        ? "!text-[#5688E5]"
                        : "inherit"
                    }`}
                  >
                    <MaterialIcon color="#141414" icon="filter_list" />
                    Filters
                  </button>
                </span>
                {Object?.keys(formData)?.length > 0 && (
                  <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                    :{Object?.keys(formData)?.length}
                    <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                  </span>
                )}
              </div>
              <div className="flex lg:flex-row flex-col lg:items-center items-start lg:gap-x-10 gap-y-5">
                <Dropdown
                  overlayStyle={{
                    width: "250px",
                  }}
                  trigger={"click"}
                  menu={{ items: settingItemsQuickActions }}
                  placement="bottom"
                >
                  <div className="w-[200px]">
                    <button className="cstm-btn flex gap-x-2" type="submit">
                      <img src={svg56} alt={svg56} /> Quick actions
                    </button>
                  </div>
                </Dropdown>
              </div>
            </div>
            <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
              <section>
                <Table
                  rowSelection={false}
                  className="mt-[1.31rem] w-full"
                  scroll={{
                    x: 800,
                  }}
                  rowKey={(record) => record?.stId}
                  columns={columns}
                  dataSource={staffItem}
                  loading={loading}
                  pagination={{
                    position: ["bottomCenter"],
                    current: pageIndex + 1,
                    total: staffItemCount,
                    pageSize: pageSize,
                    onChange: (page, size) => {
                      setPageIndex(page - 1);
                      setPageSize(size);
                      fetchStaffItemData(page - 1, size);
                    },
                    showSizeChanger: false,
                    hideOnSinglePage: true,
                  }}
                />
              </section>
            </div>
          </div>
        </div>
       

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={staffloading}
        content={`Are you sure you want to delete Staff Items for ${prodd?.ppFullname} `}
        title={`Delete Staff Items for ${prodd?.ppFullname}`}
      />

      <AddStaffTransactionModal
        handleFetchData={fetchStaffItemData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />
      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
      />

      <SalaryModal
        handleFetchData={fetchStaffItemData}
        open={openSalary}
        handleCancel={handleCancelSalary}
        prodd={prodd}
      />

      <PeriodModal
        handleFetchData={fetchStaffItemData}
        open={openPeriod}
        setopenPeriod={setopenPeriod}
        handleCancel={handleCancelPeriod}
        prodd={prodd}
      />
    </div>
  );
}
